// CORE
import React, { useContext, useState, useRef, useEffect } from "react";

// THIRD-PARTY LIBRARIES
import { Dropdown } from "react-bootstrap";
import { useIntl } from "react-intl";
import { Link } from "react-router-dom";

// COMPONENTS
import { Context } from "Wrapper";

// LANGUAGES
import Arabic from "lang/ar.json";
import English from "lang/en.json";

// ASSETS (SVGs)
import { ReactComponent as LangIcon } from "./assets/svg/lang.svg";

const LanguageControl = () => {
    const { locale } = useIntl();

    const context = useContext(Context);

    const [langSwitchOpen, setLangSwitchOpen] = useState(false);
    const langDropdownRef = useRef(null);
    const toggleLangDropdown = () => setLangSwitchOpen(!langSwitchOpen);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                langDropdownRef.current &&
                !langDropdownRef.current.contains(event.target)
            ) {
                setLangSwitchOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    const handleChangeLangOnClick = (locale) => {
        localStorage.setItem("lang", locale);
        context.setLocale({
            lang: locale,
            messages: locale === "ar" ? Arabic : English,
        });

        document.body.setAttribute("dir", locale === "ar" ? "rtl" : "ltr");
        document.documentElement.lang = locale === "ar" ? "ar" : "en";
        document.querySelector("title").textContent =
            locale === "ar" ? "لوحة التحكم" : "Dashboard";
    };
    return (
        <div className="dropdown-container" ref={langDropdownRef}>
            <div className="dropdown-toggler" onClick={toggleLangDropdown}>
                <LangIcon className="language-icon" />
                <span className="language-name">
                    {locale === "ar" ? "العربية" : "English"}
                </span>
            </div>

            <div
                className={`dropdown-menu ${
                    langSwitchOpen ? "fade-in" : "fade-out"
                }`}
            >
                <div className="dropdown-content">
                    <Link
                        to={`#!`}
                        onClick={(event) => {
                            event.preventDefault();
                            handleChangeLangOnClick("ar");
                        }}
                    >
                        <Dropdown.Item as={"span"}>العربية</Dropdown.Item>
                    </Link>
                    <Link
                        to={`#!`}
                        onClick={(event) => {
                            event.preventDefault();
                            handleChangeLangOnClick("en");
                        }}
                    >
                        <Dropdown.Item as={"span"}>English</Dropdown.Item>
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default LanguageControl;
